/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  style.ts
 */

import { css } from '@emotion/react'

export const saveSearchBtn = css`
  height: 20px;
  width: 20px;
  min-width: 20px;
  padding: 0;
`
